import { Box, formatMoney, Text } from '@betty/moonlight';
import { useCashBalance } from '@betty/wallet';

function BalanceCard() {
  const { cashBalance, bonusBalance } = useCashBalance();

  return (
    <Box
      justifyContent="center"
      alignItems="center"
      backgroundColor="secondaryBackgroundHover"
      padding="space-400"
      borderRadius="radius-200"
      gap="space-400"
      minWidth="100%"
    >
      <Box gap="space-100">
        <Text
          variant="body-s-semi"
          color="darkSurfaceTertiary"
          textAlign="center"
          locKey="cashBalance"
          locNS="account"
        />
        <Text variant="h3" gradient="darkSurfaceAccent">
          {formatMoney(cashBalance)}
        </Text>
      </Box>
      <Box gap="space-100">
        <Text
          variant="body-s-semi"
          color="darkSurfaceTertiary"
          textAlign="center"
          locKey="bonusBalance"
          locNS="account"
        />
        <Text variant="h3" gradient="darkSurfaceAccent">
          {formatMoney(bonusBalance)}
        </Text>
      </Box>
    </Box>
  );
}

export default BalanceCard;
